import React from 'react'
import { SiteLayoutProps } from "./SiteLayout";
import ProductsHeader from "./ProductsHeader";
import Content from "./Content";
import ErrorBoundary from "@Components/ErrorBoundary";

const ProductsSiteLayout = ({
  children,
  className,
  title,
  ref
}: React.PropsWithChildren<SiteLayoutProps>) => {
  return (
    <>
      <ProductsHeader title={title} />
      <Content className={className} ref={ref} heading={title}>
        <ErrorBoundary>{children}</ErrorBoundary>
      </Content>
    </>
  );
};

export default ProductsSiteLayout;